import { batch } from 'react-redux';
import { get_user_attr } from './user_auth_action';
import tracking from '../utils/tracking';

export const exercise_actions = {
  SET_CATEGORIES: '@EXERCISE/SET_CATEGORIES',
  SET_ASSIGNMENTS: '@EXERCISE/SET_ASSIGNMENTS',
  SET_EXERCISE_HISTORY: '@EXERCISE/SET_EXERCISE_HISTORY',
  SET_ALL_EXERCISES: '@EXERCISE/SET_ALL_EXERCISES',
  SET_ACTIVE_EXERCISE: '@EXERCISE/SET_ACTIVE_EXERCISE',
  SET_BEFORE_RATING: '@EXERCISE/SET_BEFORE_RATING',
  SET_AFTER_RATING: '@EXERCISE/SET_AFTER_RATING',
  SET_STEP_ANSWER: '@EXERCISE/SET_STEP_ANSWER',
  CLEAR_ACTIVE_STEP: '@EXERCISE/CLEAR_ACTIVE_STEP',
  SET_COMPLETED_EXERCISE: '@EXERCISE/SET_COMPLETED_EXERCISE'
};

export const setCategories = categories => ({
  type: exercise_actions.SET_CATEGORIES,
  categories
});

export const setAssignments = assignments => ({
  type: exercise_actions.SET_ASSIGNMENTS,
  assignments
});

export const setExerciseHistory = exercises => ({
  type: exercise_actions.SET_EXERCISE_HISTORY,
  exercises
});

export const setAllExercises = allExercises => ({
  type: exercise_actions.SET_ALL_EXERCISES,
  allExercises
});

export const setActiveExerciseId = exercise_id => ({
  type: exercise_actions.SET_ACTIVE_EXERCISE,
  exercise_id
});

export const setBeforeRating = rating_before => ({
  type: exercise_actions.SET_BEFORE_RATING,
  payload: { rating_before }
});

export const setAfterRating = rating_after => ({
  type: exercise_actions.SET_AFTER_RATING,
  payload: { rating_after }
});

export const clearActiveStep = () => ({
  type: exercise_actions.CLEAR_ACTIVE_STEP
});

export const setCompletedExercise = payload => ({
  type: exercise_actions.SET_COMPLETED_EXERCISE,
  payload
});

export const fetchExerciseHistory = axiosApi => async (dispatch, getState) => {
  const user = get_user_attr(getState());

  try {
    const { data: completed } = await axiosApi.get(`/api/patients/${user.patient.id}/exercise_patients/completed`);
    batch(() => {
      dispatch(setExerciseHistory(completed));
    });
  } catch (err) {
    tracking.errorV2('Error fetch exercise history', err, {
      tags: ['exercise', 'error'],
      parentId: user.patient.id
    });
  }
};

export const fetchExerciseData = axiosApi => async (dispatch, getState) => {
  const user = get_user_attr(getState());

  try {
    const { data: categories } = await axiosApi.get('/api/categories');
    const { data: assignments } = await axiosApi.get(`/api/patients/${user.patient.id}/exercise_patients/assigned`);
    const { data: exercises } = await axiosApi.get('/api/exercises');

    batch(() => {
      dispatch(setCategories(categories));
      dispatch(setAssignments(assignments));
      dispatch(setAllExercises(exercises));
    });
  } catch (err) {
    tracking.errorV2('Error fetch exercise data', err, {
      tags: ['exercise', 'category', 'error'],
      parentId: user.patient.id
    });
  }
};

export const setStepAnswer = ({ step_id, answer }) => ({
  type: exercise_actions.SET_STEP_ANSWER,
  payload: { step_id, answer }
});

export const completeExercise = (axiosApi, rating_after) => async (dispatch, getState) => {
  if (rating_after) dispatch(setAfterRating(rating_after));
  const user = get_user_attr(getState());
  const activeStepPayload = getState().exercise_reducer.active_exercise;

  try {
    const { data } = await axiosApi.post(
      `/api/patients/${user.patient.id}/exercise_patients/complete`,
      activeStepPayload
    );
    batch(() => {
      dispatch(setCompletedExercise(data));
      dispatch(fetchExerciseData(axiosApi));
    });
  } catch (err) {
    tracking.errorV2('Error complete exercise', err, {
      tags: ['exercise', 'error'],
      parentId: user.patient.id,
      payload: activeStepPayload
    });
  }
};

export const sendExerciseAnswers =
  (axiosApi, exercise_id, exercise_patient_id, send = false) =>
  async (dispatch, getState) => {
    const user = get_user_attr(getState());

    try {
      await axiosApi.post(
        `/api/patients/${user.patient.id}/exercise_patients/${exercise_patient_id}/share_with_doctor`,
        {
          exercise_id,
          patient_id: user.patient.id,
          share_with_doctor: send
        }
      );
      dispatch(clearActiveStep());
    } catch (err) {
      tracking.errorV2('Error send exercise answers', err, {
        tags: ['exercise', 'error'],
        patientId: exercise_patient_id,
        exerciseId: exercise_id,
        shareWithDoctor: send
      });
    }
  };

export const dismissExercise = (axiosApi, exercise_patient_id) => async (dispatch, getState) => {
  const user = get_user_attr(getState());

  try {
    await axiosApi.delete(`/api/patients/${user.patient.id}/exercise_patients/${exercise_patient_id}/unassign_mobile`);
    dispatch(fetchExerciseData(axiosApi));
  } catch (err) {
    tracking.errorV2('Error dismiss exercise', err, {
      tags: ['exercise', 'error'],
      patientId: exercise_patient_id
    });
  }
};
